import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { map, switchMap, catchError } from 'rxjs/operators';
import { CREATE_AUDIENCE, CREATE_AUDIENCE_SUCCESS } from '../../constants';

import { toast } from 'react-toastify';

let toastId = 'createAudience';

const createAudience = (action$, state$) =>
  action$.pipe(
    ofType(CREATE_AUDIENCE),
    switchMap(action => {

      const bodyPayload = {
        type: state$.value.audienceBuilder.audienceType,
        clientId: action.clientId,
        since: state$.value.audienceBuilder.since,
        until: state$.value.audienceBuilder.until,
        dataSource: state$.value.audienceBuilder.dataSource,
      };

      if (state$.value.audienceBuilder.audienceType === 'organization') {
        bodyPayload.organizationIds = state$.value.audienceBuilder.organisation.map(
          item => item.value
        );
      } else if (state$.value.audienceBuilder.audienceType === 'subcategory') {
        bodyPayload.subcategories = state$.value.audienceBuilder.industry.map(
          item => item.label
        );
      }
      // set location data array
      if (
        state$.value.audienceBuilder.home !== null &&
        state$.value.audienceBuilder.home.length > 0
      ) {
        bodyPayload.locationIds = state$.value.audienceBuilder.home.map(
          item => item.value
        );
      }

      return ajax({
        url: `${state$.value.auth.audienceBuilderServer}/audiences`,
        headers: {
          Authorization: state$.value.auth.token,
          'Content-Type': 'application/json',
        },
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(bodyPayload),
        method: 'POST',
      }).pipe(
        map(response => {
          return {
            type: CREATE_AUDIENCE_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error => {

          console.log(error);

        } )
      );
    })
  );

export default createAudience;
